import { useRecoilValue } from 'recoil';
import { reportAlarmsState } from '../../../storage/reports';
import AlarmsReportTable from './AlarmsReportTable';

type Props = Readonly<{
  assetId: string;
}>;

function AlarmsReportTableFromAsset({ assetId }: Props) {
  const states = useRecoilValue(reportAlarmsState(assetId));

  return <AlarmsReportTable states={states} />;
}

export default AlarmsReportTableFromAsset;
